export const handleHttpErrorStatus = (res) => res.ok ? res : Promise.reject(res);